import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

/* eslint import/namespace: ['error', { allowComputed: true }]*/
import * as Icons from './icons';
import {UrgencyMessages} from './messages';

import '../styles/urgency.scss';

const EventUrgency = ({urgencyMessage = {}, intl, urgencyConfig = {}, hideUrgencyIcon = false}) => {
  let urgency;

  /**
   * Get the First Urgency Type from the Urgency Message Object
   *
   */
  let urgencyMessageType = (Object.keys(urgencyMessage) || [])[0];

  /**
   * Get the Urgency message only if the `urgencyConfig` has the `urgencyMessageType` enabled
   *
   */
  let urgencyMessageUnformedText =
    urgencyMessageType &&
    urgencyConfig &&
    urgencyConfig.enableUrgency &&
    urgencyConfig[urgencyMessageType] &&
    (UrgencyMessages[urgencyMessageType] || '');

  if (urgencyMessageUnformedText) {
    let urgencyMessageText =
      urgencyMessageUnformedText && intl.formatMessage(urgencyMessageUnformedText, {...urgencyMessage});
    let urgencySVGIcon = hideUrgencyIcon ? null : Icons[urgencyMessageType]({});
    urgency = (
      <div className="EventUrgency__container">
        {urgencySVGIcon}
        <span className="EventUrgency__message">{urgencyMessageText}</span>
      </div>
    );
  } else {
    urgency = null;
  }

  return urgency;
};

EventUrgency.contextTypes = {
  urgencyConfig: PropTypes.object,
};

EventUrgency.propTypes = {
  urgencyMessage: PropTypes.object,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(EventUrgency);
